import { call, all } from 'redux-saga/effects';
import { LoginActionWatcher } from '../containers/LoginContainer/saga';
import { feedbackActionWatcher } from '../containers/FeedbackContainer/saga';
import { ForgotpasswordActionWatcher } from '../containers/FrgtPswdContainer/saga';
import { countryActionWatcher } from '../containers/CountryContainer/saga';
import { distributorActionWatcher } from '../containers/DistributorProfileContainer/saga';
import { currencyActionWatcher } from '../containers/CurrencyContainer/saga';
import { CountryCrncyActionWatcher } from '../containers/CountryCrncyContainer/saga';
import { unitActionWatcher } from '../containers/UnitContainer/saga';
import { paymentmodeActionWatcher } from '../containers/PaymentModeContainer/saga';
import { brandActionWatcher } from '../containers/BrandContainer/saga';
import { LicenseeActionWatcher } from '../containers/LicenseeContainer/saga';
import { appversionActionWatcher } from '../containers/AppversionContainer/saga';
import { dashboardActionWatcher } from '../containers/DefaultLayout/saga';
//import { SignUpActionWatcher } from "../containers/SignUpContainer/saga";
import { PatientsActionWatcher } from '../containers/PatientsProfileContainer/saga';
import { PatientPaymentActionWatcher } from '../containers/PatientPaymentContainer/saga';
import { PatientInvoiceActionWatcher } from '../containers/PatientInvoiceContainer/saga';
import { SupportActionWatcher } from '../containers/SupportContainer/saga';
import { SupportUsersActionWatcher } from '../containers/SupportUsersContainer/saga';
import { ItemCategoryActionWatcher } from '../containers/ItemCategoryContainer/saga';
import { ChemistActionWatcher } from '../containers/ChemistProfileContainer/saga';
import { ChemistPaymentActionWatcher } from '../containers/ChemistPaymentContainer/saga';
import { ChemistInvoiceActionWatcher } from '../containers/ChemistInvoiceContainer/saga';
import { ChemistOrderActionWatcher } from '../containers/ChemistOrderContainer/saga';
import { PatientsOrderActionWatcher } from '../containers/PatientsOrderContainer/saga';
import { ItemMasterActionWatcher } from '../containers/ItemMasterContainer/saga';
import { StateActionWatcher } from '../containers/StateContainer/saga';
import { DistrictActionWatcher } from '../containers/DistrictContainer/saga';
import { SupportTypeActionWatcher } from '../containers/SupportTypeContainer/saga';
import { AuditTraceActionWatcher } from '../containers/AuditTraceContainer/saga';
import { ProductReturnActionWatcher } from '../containers/ProductReturnsContainer/saga';
import { ExpiryReturnsActionWatcher } from "../containers/ExpiryReturnsContainer/saga";
import { CreditNotesActionWatcher } from '../containers/CreditNotesContainer/saga';
import { DeliveryStausActionWatcher } from '../containers/DeliveryStatusContainer/saga';
import { HelplineActionWatcher } from '../containers/HelplineContainer/saga';
import { BankActionWatcher } from '../containers/BankContainer/saga';
import { termsandconditionActionWatcher } from '../containers/TermsandConditionContainer/saga';
import { cpvalueActionWatcher } from '../containers/CpvalueContainer/saga';
import { gstMasterActionWatcher } from '../containers/GstMasterContainer/saga';

function* rootSaga() {
  yield all([
    call(PatientsActionWatcher),
    call(PatientPaymentActionWatcher),
    call(PatientInvoiceActionWatcher),
    call(ChemistActionWatcher),
    call(ChemistPaymentActionWatcher),
    call(ChemistInvoiceActionWatcher),
    call(ChemistOrderActionWatcher),
    call(LoginActionWatcher),
    call(feedbackActionWatcher),
    //call(SignUpActionWatcher),
    call(ForgotpasswordActionWatcher),
    call(countryActionWatcher),
    call(distributorActionWatcher),
    call(currencyActionWatcher),
    call(CountryCrncyActionWatcher),
    call(unitActionWatcher),
    call(paymentmodeActionWatcher),
    call(brandActionWatcher),
    call(LicenseeActionWatcher),
    call(appversionActionWatcher),
    call(dashboardActionWatcher),
    call(SupportActionWatcher),
    call(SupportUsersActionWatcher),
    call(PatientsOrderActionWatcher),
    call(ItemCategoryActionWatcher),
    call(ItemMasterActionWatcher),
    call(StateActionWatcher),
    call(DistrictActionWatcher),
    call(SupportTypeActionWatcher),
    call(ProductReturnActionWatcher),
    call(ExpiryReturnsActionWatcher),
    call(CreditNotesActionWatcher),
    call(AuditTraceActionWatcher),
    call(DeliveryStausActionWatcher),
    call(termsandconditionActionWatcher),
    call(HelplineActionWatcher),
    call(BankActionWatcher),
    call(cpvalueActionWatcher),
    call(gstMasterActionWatcher),
  ]);
}

export default rootSaga;
